<template>
  <div class="login-tag is-size-3 line-height">
		<div class="column">
			<div class="columns">
				<div class="column is-three-fifths is-offset-one-fifth">
					<div class="signup-col box has-text-dark policy-col pt-0">
						<div class="header-logo-sticky">
						<img src="../assets/logo-login.svg" width="350" class="has-text-centered mb-2">
						<h2 class="is-size-2 has-text-weight-semibold">1. Manufacton User Privacy Policy</h2>
						<p>Effective Date: May 7, 2025</p>
						</div>
						<h3 class="has-text-weight-semibold">Introduction</h3>
						<p>Design Data Corp, dba SDS2 and ALLPLAN, a Nebraska Corporation (together, "ALLPLAN") 
							(collectively referred to herein as ALLPLAN, “we”, “our” or “us”) recognize the importance of 
							protecting personal information we may collect from visitors and any other individuals or 
							entities (“Users”, “you”, or “your”) who Manufacton web sites or use the Manufacton Service. 
							This Privacy Policy applies to data collection by ALLPLAN and shall apply to your use of the 
							website, manufacton.com and other Manufacton-related sites, applications, software, 
							communications, capabilities and services (“Services”) accessible on or by the 
							manufacton.com website or any interface to the Manufacton Service (each, a “Site” and 
							collectively the “Sites”), but excluding services that state that they are offered under a 
							different privacy policy. The “Manufacton Service” means ALLPLAN’s Manufacton-branded 
							software-as-a-service collaboration and logistics software platform, which ALLPLAN makes 
							available to Users as a service over the Internet.</p>
							<p>Our Privacy Policy explains: (1) what information we collect; (2) why we collect it; (3) how we 
							use that information; (4) how we may share it; (5) the choices we offer, including how to 
							access and update information; (6) and the measures we take to keep your information safe.
							</p>
							<p>Please familiarize yourself with our privacy practices and let us know if you have any 
							questions. By using the Sites, you signify your acceptance of this Privacy Policy. If you do not 
							agree to this Privacy Policy, please do not use the Sites</p>
							<p>Irrespective of which country you live in, you authorize us to transfer, store, and use your 
							information in the United States, and any other country where we operate. In some of these 
							countries, the privacy and data protection laws and rules regarding when government 
							authorities may access data may vary from those in the country where you live. Learn more 
							about our data transfer operations in the “International Transfer” section below. If you do not 
							agree to the transfer, storage and use of your information in the United States, and any other 
							country where we operate, please do not use the Sites or Services</p>
							<p>If you have any questions or comments about this Privacy Policy, please submit a request to 
							dataprotectionofficer@allplan.com.</p>

							<h3 class="has-text-weight-semibold">When this Privacy Policy Applies</h3>
							<p>
								Our Privacy Policy applies to all of the Services offered by ALLPLAN and its affiliates, 
							including some ALLPLAN Partners, and Services offered on other sites, but excludes 
							services that have separate privacy policies that do not incorporate this Privacy Policy.
							</p>
							<p>
								Our Privacy Policy does not apply to services offered by other companies or individuals, 
							including products or sites that may be displayed to you, or other sites linked from our 
							Services. Our Privacy Policy does not cover the information practices of other companies 
							and organizations who advertise our Services, and who may use cookies, pixel tags and other 
							technologies to serve and offer relevant ads. By accessing or using the Sites or Services in 
							any manner, you also agree to be bound by ALLPLAN’s Terms of Use (the “Agreement”). 
							Please read the Agreement carefully. If you do not accept all of the terms and conditions 
							contained in or incorporated by reference into the Agreement, please do not use the Sites or 
							Services.
							</p>
							<h3 class="has-text-weight-semibold">Information We Collect</h3>
							<p>We collect information, including personal information, to provide better services to all our 
							Users. We use the term “Personal Information” to refer to any information that identifies or 
							can be used to identify you. Common examples of Personal Information include: full name, 
							email address, digital identity, such as a login name or handle, information about your device, 
							and certain metadata</p>
							<p>When you use our Services, we collect Personal Information in the following ways:</p>
							<h3 >1. Information You Give to Us</h3>
							<p>When you (or your employer or other sponsor) create an account, you may submit Personal 
							Information to us when completing forms on our website. This Personal Information may 
							include your first and last name, email address, phone number. For instance, you may 
							choose to provide us with Personal Information about yourself, including your name, 
							company name, and email address by completing forms on our website, such as when you 
							request to see a demo. In addition to this information, when you use our platform, an online 
							payment card transaction may be required. During this process, you may provide us with the 
							first and last name of the payment card owner, payment card billing address, payment card 
							number, payment card expiration date, card verification value (“CVV”).</p>
							<p>In some instances, you may elect to provide us with location and address information. You 
							may also provide us with Personal Information about yourself when you report a problem or 
							have a question about our services. In other cases, we may collect general location 
							information based on your login to our system.</p>

							<p>The Sites offer interactive and social features that permit you to submit content and 
							communicate with us. You may provide Personal Information to us when you post 
							information in these interactive and social features. Please note that your postings in these 
							areas of the Sites may be publicly accessible or accessible to other Users.</p>
							<h3>2. Information We Obtain from Your Use of Our Site and Services</h3>
							<p>We obtain certain information automatically, such as your operating system version, 
							browser type, and internet service provider. When you use our Site, we automatically collect 
							and store this information in service logs. This includes: details of how you used our Site; 
							Internet protocol address; and cookies that uniquely identify your browser. The information 
							we collect automatically is statistical data and may or may not include Personal Information, 
							but we may maintain it or associate it with personal information we collect in other ways or 
							receive from third parties.</p>

							<h3>3. Cookies and Similar Technologies</h3>

							<p>We and our partners use various technologies to collect and store information when you visit 
							one of our services, and this may include using cookies or similar technologies to identify 
							your browser or device. We also use these technologies to collect and store information 
							when you interact with services from our partners, such as advertising services. Our third 
							party advertising and analytics partners include Google and similar partners.</p>
							<p>The technologies we use for this automatic data collection may include:</p>

							<p>Cookies. A cookie is a small file placed on the hard drive of your computer. You may refuse 
							to accept browser cookies by activating the appropriate setting on your browser. However, if 
							you select this setting you may be unable to access certain parts of our services. Unless you 
							have adjusted your browser setting so that it will refuse cookies, our system will issue 
							cookies when you direct your browser to our services.</p>

							<p>Web Beacons. Pages of our services or our e-mails may contain small electronic files known 
							as web beacons (also referred to as clear gifs, pixel tags and single-pixel gifs) that permit us, 
							for example, to count Users who have visited those pages or opened an e-mail and for other 
							related website statistics (for example, recording the popularity of certain website content 
							and verifying system and server integrity)</p>

							<p>Clickstream Data. Clickstream data is information collected by our computers when you 
							request Web pages from the Sites. Clickstream data may include information such as the 
							page served, the time spent viewing the page, source of the request, type of browser making 
							the request, the preceding page viewed and similar information. Clickstream data permits
							us to analyze how visitors arrive at the Sites, what type of content is popular, what type of 
							visitors in the aggregate are interested in particular kinds of content on the Sites.</p>

							<h3  class="has-text-weight-semibold">How We Use Information We Collect</h3>

							<p>We use your Personal Information in ways that are compatible with the purposes for which it 
							was collected or authorized by you, including for the following purposes:</p>
							<ol>
									<li>To present, operate or improve the Site and Services, including analysis of Site activity;</li>

									<li>To inform you about Services and products available from ALLPLAN and its affiliates and 
							business partners;</li>

							<li>To authorize access to our Sites and Services;</li>

							<li>To provide, maintain, administer or expand the Services, performing business analyses, or 
							for other internal purposes to support, improve or enhance our business, the Services, and 
							other products and services we offer;</li>

							<li> To offer and administer programs;</li>

							<li>To customize or tailor your experience of the Services;</li>

							<li>To administer content, promotion, sweepstakes, surveys, voting polls or other Site 
							features;</li>

							<li>To communicate about, and administer your participation in, special programs, surveys, 
							contests, online campaigns, online programs, sweepstakes, and other offers or promotions, 
							and to deliver pertinent emails;</li>

							<li>To improve our Site and Services;</li>

							<li> To secure our Services, including to authenticate Users;</li>

							<li>To use statistical information that we collect in any way permitted by law, including from 
							third parties in connection with their commercial and marketing efforts;</li>

							<li>To respond to and support Users regarding their use of the Sites and Services;</li>
							<li>To comply with all applicable legal requirements;</li>

							<li>To enforce our Terms of Service and other agreements;</li>

							<li> To perform data analysis and testing;</li>

							<li>To investigate possible fraud or other violations of our Terms of Service or this Privacy
							Policy and/or attempts to harm our Users;</li>
							<li>To resolve disputes;</li>
							<li>To otherwise fulfill the purpose for which the information was provided.</li>
							</ol>

							<p>We use the information we collect from our Sites to provide, maintain, and improve them, to 
							develop new services, and to protect our company and our Users.</p>

							<p>We use information collected from cookies and other technologies, to improve your User 
							experience and the overall quality of our services. We may use your Personal Information to 
							see which web pages you visit at our Site, which web site you visited before coming to our 
							Site, and where you go after you leave our Site. We can then develop statistics that help us 
							understand how our visitors use our Site and how to improve it. We may also use the 
							information we obtain about you in other ways for which we provide specific notice at the 
							time of collection.</p>

							<p>We will ask for your consent before using information for a purpose other than those set out 
							in this Privacy Policy.</p>
							<h3 class="has-text-weight-semibold">Information we share</h3>
							<p>We do not share Personal Information with companies, organizations and individuals 
							outside of ALLPLAN unless one of the following circumstances applies:</p>

							<p><span class="has-text-weight-semibold">With your consent. </span>We will share Personal Information with companies, organizations or 
							individuals outside of ALLPLAN when we have your consent to do so. This happens when you 
							submit your information through our Sites or Services.</p>

							<p><span class="has-text-weight-semibold">Enterprise Accounts.</span> Your employer or organization may offer you access to our Services. 
							We will share Personal Information with your employer. Your employer or organization can 
							review and manage your use of such enterprise Services.</p>

							<p><span class="has-text-weight-semibold">For external processing. </span>We provide Personal Information to our affiliates or other trusted 
							businesses or partners to process it for us, based on our instructions and in compliance with 
							our Privacy Policy and any other appropriate confidentiality and security measures. These 
							third parties include marketing partners, third party hosted services providers, social media 
							companies, and similar partners. It is our policy to only share Personal Information with 
							contractors, service providers and other third parties who are bound by contractual 
							obligations to keep Personal Information confidential and use it only for the purposes for 
							which we disclose it to them. Under certain circumstances, you may avoid having us share 
							your information with our business partners and vendors by not granting us permission to 
							share your information. Not granting us permission to share your information with our 
							business partners or vendors may limit your access to their services through the Sites.
							</p>

							<p><span class="has-text-weight-semibold">For Legal Reasons.</span> We will share Personal Information with companies, organizations or 
							individuals outside of ALLPLAN if we have a good-faith belief that access, use, preservation 
							or disclosure of the information is reasonably necessary to meet any applicable law, 
							regulation, legal process or enforceable governmental request, enforce applicable Terms of 
							Use, including investigation of potential violations, detect, prevent, or otherwise address 
							fraud, security or technical issues, or protect against harm to the rights, property or safety of 
							ALLPLAN, our Users or the public as required or permitted by law. We attempt to notify Users 
							about legal demands for their Personal Information when appropriate in our judgment, 
							unless prohibited by law or court order or when the request is an emergency. We may dispute 
							such demands when we believe, in our discretion, that the requests are overbroad, vague or 
							lack proper authority, but we do not promise to challenge every demand.</p>

							<p><span class="has-text-weight-semibold">Business Transfers. </span>If we establish a new related entity, are acquired by or merged with 
							another organization, or if substantially all of our assets are transferred to another 
							organization, Personal Information about our Users is often a transferred business asset. In 
							the event that ALLPLAN itself or substantially all of our assets are acquired, Personal 
							Information about our Users may be one of the transferred assets.</p>

							<p><span class="has-text-weight-semibold">Partners with Whom We Conduct Business.</span> When ALLPLAN partners with other 
							businesses to offer products and services, we may share your personal information with 
							those business partners only as needed to provide those products and services to you.</p>

							<p><span class="has-text-weight-semibold">Non-Personal and Aggregate Site Use Information. </span>ALLPLAN may compile and share your 
							information in aggregated form (i.e., in a manner that would not personally identify you) or in 
							de-identified form so that it cannot reasonably be used to identify an individual (“De-Identified Information”). We may disclose such de-identified information publicly and to 
							third parties, or to ALLPLAN partners under agreement with us.</p>

							<p class="has-text-weight-semibold">Your Choices and Accessing, Updating or Deleting Your Personal Information</p>

							<p>Whenever you use our Services, we aim to provide you with choices about how we use your 
							Personal Information. We also aim to provide you with access to your Personal Information. 
							If that information is wrong, we strive to give you ways to update it quickly or to delete it -
							unless we have to keep that information for legitimate business or legal purposes.</p>

							<p class="has-text-weight-semibold">Your Rights With Respect to Personal Information</p>

							<p>Some U.S. state laws may provide you with certain rights in connection with Personal 
							Information you have shared with us.</p>

							<p>If you need further assistance regarding your rights, please contact us using the contact 
							information provided below and we will consider your request in accordance with applicable 
							law. To make these requests, you may contact us using the contact information below, and 
							we will consider your request in accordance with applicable laws. For your protection, we 
							may need to verify your identity before responding to your request, such as verifying that the 
							email address from which you send the request matches your email address that we have 
							on file. If we no longer need to process Personal Information about you in order to provide 
							our Services or our Sites, we will not maintain, acquire or process additional information in 
							order to identify you for the purpose of responding to your request.</p>

							<p>In some cases our ability to uphold these rights for you may depend upon our obligations to 
							process personal information for security, safety, fraud prevention reasons, compliance with 
							regulatory or legal requirements, or because processing is necessary to deliver the services 
							you have requested. Where this is the case, we will inform you of specific details in response 
							to your request.</p>

							<h3 class="has-text-weight-semibold">Changing or Deleting Your Information</h3>

							<p>You may update or correct information about yourself by making changes to your profile in 
							your account or by emailing us at dataprotectionofficer@allplan.com. If you completely 
							delete all such information, then your account may become deactivated. We may retain an 
							archived copy of your records as required by law, to comply with our legal obligations, to 
							resolve disputes, to enforce our agreements or for other legitimate business purposes.</p>
							<p>We may contact you to request that you update your Personal Information on a regular basis 
							to ensure its integrity for the purposes of ongoing data management.</p>

							<h3 class="has-text-weight-semibold">Our Opt-in/Opt-out Policy</h3>

							<p>By providing an email address on the ALLPLAN Sites or Services, you agree that we may (but 
							are not required to) contact you in the event of a change in this Privacy Policy, to provide you 
							with any Service related notices, or to provide you with information about our events, 
							invitations, or related educational information.
							</p>

							<p>For purposes of this Privacy Policy, “opt-in” is generally defined as any affirmative action by 
							a User to submit or receive information, as the case may be. Your login to the Manufacton 
							Service is your express acceptance and opt-in to the User Terms of User and this Privacy 
							Policy.</p>

							<p>We currently provide the following opt-out opportunities:</p>
							<div class="privacy-cols">
								<p>At any time, you can follow a link provided in offers, newsletters or other email 
							messages (except for e-commerce confirmation or service notice emails) received 
							from us or a ALLPLAN Partner to unsubscribe from the service.
							At any time, you can contact us through dataprotectionofficer@allplan.com or the 
							address or telephone number provided below to unsubscribe from the service and 
							opt-out of our right per your consent under the terms of this Privacy Policy to share 
							your Personal Information. Notwithstanding anything else in this Privacy Policy, 
							please note that we always reserve the right to contact you in the event of a change 
							in this Privacy Policy, or to provide you with any service related notices.</p>
									<h4 class="has-text-weight-semibold">Your Ad Choices</h4>
									<p>As described above, we or third party partners may place or recognize a unique 
							cookie on your browser when you visit our Sites for the purpose of serving you 
							targeted advertising (also referred to as “online behavioral advertising” or “interest-based advertising”). 
							You may find more information about entities involved in online 
							advertising and additional choices you may make, including opt-out of having your 
							information used for internet-based advertising, through the Network Advertising 
							Initiative (“NAI”) at the <a href="https://thenai.org/" target="_blank">NAI Service</a>, and the <a href="https://optout.aboutads.info/?locale=en-US" target="_blank">Digital Advertising Alliance</a> (the “DAA”) at 
							the <a href="https://optout.aboutads.info/?locale=en-US" target="_blank">DAA consumer choice service.</a> ALLPLAN is a participant in the online industry’s 
							self-regulatory program administered by the DAA and has agreed to adhere to the 
							DAA’s principles applicable to interest-based ads.</p>

							<p>The tools provided at the <a href="https://optout.aboutads.info/?locale=en-US" target="_blank">DAA opt-out page</a>
								and the <a href="https://thenai.org/glossary/opt-out-mechanism/" target="_blank">NAI opt-out page</a> are provided by 
							third parties, not ALLPLAN. ALLPLAN does not control or operate these tools or the 
							choices that advertisers and others provide through these tools.</p>


							
							
							<h4 class="has-text-weight-semibold is-size-3">Third Party Links</h4>
							<p>The Sites may contain links to webpages operated by parties other than ALLPLAN. We 
							do not control such websites and are not responsible for their contents or the privacy 
							policies or other practices of such websites. Our inclusion of links to such websites 
							does not imply any endorsement of the material on such websites or any association 
							with their operators. Further, it is up to the User to take precautions to ensure that 
							whatever links the User selects or software the User downloads (whether from this 
							Site or other websites) is free of such items as viruses, worms, trojan horses, defects 
							and other items of a destructive nature. These websites and services may have their 
							own privacy policies, which the User will be subject to upon linking to the third party's 
							terms and policies.</p>

							<h4 class="has-text-weight-semibold is-size-3">Your California Privacy Rights</h4>

							<p>California Civil Code Section § 1798.83 permits Users of our Site that are California 
							residents to request certain information regarding our disclosure of personal 
							information to third parties for their direct marketing purposes. We do not disclose 
							personal information to third parties for their own marketing purposes. If for any 
							reason you would like more information concerning our practice, California users 
							may request further information by contacting us at 
							dataprotectionofficer@allplan.com or by writing to us at the address listed in the 
							“How to Contact Us” section. Other states may include similar rights, and you may 
							request further information for your specific state by contacting us at 
							dataprotectionofficer@allplan.com or by writing to us at the address listed in the 
							“How to Contact Us” section.</p>

							<h4 class="has-text-weight-semibold is-size-3">How We Protect Personal Information</h4>
							<p>ALLPLAN maintains administrative, technical and physical safeguards designed to 
							protect the User's Personal Information and information against accidental, unlawful 
							or unauthorized destruction, loss, alteration, access, disclosure or use. We 
							implement appropriate technical and organizational measures to ensure a level of 
							security appropriate to the risk, taking into account technological reality, cost, the 
							scope, context and purposes of processing weighted against the severity and 
							likelihood that the processing could threaten individual rights and freedoms. For 
							example, we restrict access to personal information to ALLPLAN employees, 
							contractors, business partners and agents who need to know that information in 
							order to operate, develop or improve our services. These individuals are bound by 
							confidentiality obligations and may be subject to discipline, including termination
							and criminal prosecution, if they fail to meet these obligations. We use commercially 
							reasonable security measures such as encryption, firewalls, and Secure Socket 
							Layer software (SSL) or hypertext transfer protocol secure (HTTPS) to protect Personal 
							Information.</p>
							<p>If ALLPLAN collects account information for payment or credit, ALLPLAN will use the 
							information only to complete the task for which the account information was offered.</p>

							<h4 class="has-text-weight-semibold is-size-3">Children</h4>
							<p>The Site is not intended for use by children. We do not intentionally gather Personal 
							Information about visitors who are under the age of 13. If a child has provided us with 
							Personal Information, a parent or guardian of that child may contact us to have the 
							information deleted from our records. If you believe that we might have any 
							information from a child under age 13 in the applicable jurisdiction, please contact 
							us at request further information by contacting us at 
							dataprotectionofficer@allplan.com . If we learn that we have inadvertently collected 
							the personal information of a child under 13, or equivalent minimum age depending 
							on jurisdiction, we will take steps to delete the information as soon as possible.</p>

							<h4 class="has-text-weight-semibold is-size-3">“Do Not Track” Signals</h4>
							<p>ALLPLAN does not track its users over time and across third party websites to provide 
							targeted advertising and therefore does not respond to Do Not Track (DNT) signals. 
							However, some third party sites do keep track of your browsing activities when they 
							serve you content, which enables them to tailor what they present to you. If you are 
							visiting such sites, your browser may include controls to block and delete cookies, 
							web beacons and similar technologies, to allow you to opt out of data collection 
							through those technologies.</p>

							<h4 class="has-text-weight-semibold is-size-3">ALLPLAN Customers</h4>
							<p>ALLPLAN customers (“ALLPLAN Customers”) engage us to deliver Services to their 
							employees, customers and other users. Customer Information, Information about 
							our Customer’s Contacts and Archival Information (each defined below) are 
							governed by this Privacy Policy, the ALLPLAN Terms of Use and any other services 
							agreements between ALLPLAN and the applicable Customer.</p>

							<p><span class="has-text-weight-semibold">ALLPLAN Customer Information.</span> We collect information about individuals within 
							our ALLPLAN Customer organization (“Customer Information”). Customer 
							Information may include information related to the Customer’s account, name, work 
							e-mail address, work phone number, job title or similar kinds of information. We use 
							Customer Information to support the Customer account, maintain our business 
							relationship with the Customer, respond to Customer inquiries, or perform 
							accounting functions. ALLPLAN Customer may update personal information and 
							password by logging into the ALLPLAN Platform and updating their account. ALLPLAN
							Customers may contact ALLPLAN support in order to delete their Personal Data. In 
							some cases, we may not be able to delete Customer Information, and in such cases 
							we will tell you why.</p>

							<p><span class="has-text-weight-semibold">
							Information about our Customer’s Contacts.
							</span>We collect information about any 
							contacts, such as employees, customers, and others, that may be uploaded into the 
							ALLPLAN Platform or the Manufacton Service (“Information about our Customer’s 
							Contacts”). Information about our Customer’s Contacts may include name, e-mail 
							address, phone number, job title, or similar kinds of information. We use Information 
							about our Customer’s Contacts for the purposes of providing Services to such 
							contacts as directed by the user. ALLPLAN Customers may update or delete 
							Information about their contacts in the ALLPLAN Platform. ALLPLAN Customers may 
							also contact ALLPLAN support in order to update and delete such information. In 
							some cases, we may not be able to delete such information, and in such cases we 
							will tell you why.
							</p>
							<p>
								<span class="has-text-weight-semibold">Archival Information.</span> We collect communications information for archival purposes 
							on behalf of, and as directed by, our ALLPLAN Customers. This information may 
							include emails, texts, websites, social media messages or posts, and other forms of 
							data or electronic communications (“Archival Information”). Archival Information 
							includes data about our ALLPLAN Customers and the third parties they correspond 
							with. We do not control or monitor the information our ALLPLAN Customers collect 
							and store through our services, or the Customer’s privacy practices or policies. It is 
							our Customer’s obligation to obtain all necessary consents and to comply with all 
							applicable laws with respect to Customer’s communications and use of our services. 
							Our Customers should ensure that their privacy policies or practices apply to and 
							incorporate Archival Information. The Customer’s privacy policies or practices, 
							separate from this Privacy Policy, should also apply to the purposes for which the 
							Customer collects Archival Information, how the Customer may use Archival 
							Information and what choices the individual may have with respect to Archival 
							Information. Individuals must contact the applicable Customer in order to correct, 
							amend, or delete their information, or to opt out of any collection, uses or disclosure 
							of their information by our Customer.
							</p>

							<p><span class="has-text-weight-semibold">Automatically Collected Information.</span> 
							We collect information automatically about 
							how our ALLPLAN Customers use our services (“Automatically Collected 
							Information”). We do this via data collection technologies such as cookies, web 
							beacons, gifs or other tracking technologies. We collect this information in order to 
							monitor, support and improve our services or to provide ALLPLAN Customers with 
							certain customized features. We may use Automatically Collected Information to tell 
							us how our ALLPLAN Customers use our services, to improve our services or develop 
							new products, services or features. We may combine this information with other 
							information we collect.
							</p>

							<p>We treat Customer Information, Information about our Customer’s Contacts, 
							Archival Information and Automatically Collected Information as confidential and 
							proprietary information of our Customers, subject to the terms of the ALLPLAN Terms 
							of Use and any other service agreement between ALLPLAN and the Partner. We do 
							not share Partner Information, Information about our Customer’s Contacts, Archival 
							Information or Automatically Collected Information with third parties unless directed 
							to do so by our Customer, as may be necessary to provide services to the Customer, 
							to our advisors, affiliates, representatives, agents, service providers, in connection 
							with a business transaction (such as a merger or sale), as allowed under the terms of 
							our agreement with our Customer, or in response to a court order, subpoena, warrant 
							or to comply with a legal requirement or to cooperate with an investigation. We may 
							disclose Customer Information, Information about our Customer’s Contacts, 
							Archival Information or Automatically Collected Information for the aforementioned 
							reasons, or in order to protect our rights or the rights of our affiliates, ALLPLAN
							Customer, channel partners or service providers.</p>

							<p>We will retain Customer Information we process on behalf of our ALLPLAN
							Customers for as long as needed to provide services to our Partner, or for the period 
							of time requested by a particular Customer.</p>
							<h4 class="has-text-weight-semibold is-size-3">Changes to this Privacy Policy</h4>
							<p>Our Privacy Policy may change from time to time. We will not reduce your rights under 
							this Privacy Policy without your explicit consent. We will post any privacy policy 
							changes on this page and, if the changes are significant, we will provide a more 
							prominent notice (which may include, for certain services or programs, email 
							notification or privacy policy changes). We will also keep prior versions of this Privacy 
							Policy in an archive for your review.</p>

							<h4 class="has-text-weight-semibold is-size-3">How to Contact Us</h4>
							<p>If you have any specific questions about this Privacy Policy, you can contact us via<br>
							email or by writing to us at the address below:<br>
							Send e-mail to <span class="has-text-weight-semibold is-size-3">dataprotectionofficer@allplan.com.</span><br>
							Send mail to our address:<br>
							Design Data Corp, DBA ALLPLAN<br>
							Attn: Privacy Policy Inquiry<br>
							8333 Glynoaks Dr. Ste 200<br>
							Lincoln, NE 68516.</p>
							</div>
					</div>
				</div>
			</div>
		</div>    
  </div>
</template>

